"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSignUpEventData = exports.GiftCardPurchaseEventData = exports.CurrencyEarnEventData = exports.CurrencySpendEventData = exports.VirtualCurrencyEarnReasonEnum = exports.VirtualCurrencyEarnReason = exports.VirtualCurrencySpendReasonEnum = exports.VirtualCurrencySpendReason = exports.AnalyticVirtualCurrencyEnum = exports.AnalyticVirtualCurrency = exports.ParsedEmailResultDoc = exports.ParsedEmailResult = exports.ReceiptItemReward = exports.EmailParseRequest = exports.ReceiptFound = exports.ReceiptFoundRewardable = exports.ReceiptFoundRejected = void 0;
exports.isReceiptRewardable = isReceiptRewardable;
const zod_1 = require("zod");
const types_1 = require("../types");
const DefaultEventData = zod_1.z.object({
    /** GUID assigned to the event */
    event_id: zod_1.z.string(),
    /** Timestamp in microseconds */
    time: zod_1.z.number(),
    user_id: zod_1.z.string().optional(),
});
exports.ReceiptFoundRejected = zod_1.z
    .object({
    email_id: zod_1.z.string().optional(),
    rejection_reason: zod_1.z.string(),
    valid_for_rewards: zod_1.z.boolean(),
    receipt_type: zod_1.z.string(),
    receipt_timestamp: zod_1.z.string().or(zod_1.z.date()).optional(),
    currency: zod_1.z.string().optional(),
    purchase_amount: zod_1.z.number().optional(),
})
    .merge(DefaultEventData.partial());
exports.ReceiptFoundRewardable = zod_1.z
    .object({
    email: zod_1.z.string(),
    email_id: zod_1.z.string(),
    valid_for_rewards: zod_1.z.boolean(),
    currency: zod_1.z.string().optional(),
    purchase_amount: zod_1.z.number(),
    receipt_type: zod_1.z.string(),
    order_id: zod_1.z.string(),
    receipt_timestamp: zod_1.z.string().or(zod_1.z.date()),
    unified_app_id: zod_1.z.string(),
    has_other_items: zod_1.z.boolean(),
    item_price_no_tax: zod_1.z.number(),
})
    .merge(DefaultEventData.partial());
exports.ReceiptFound = zod_1.z.union([exports.ReceiptFoundRejected, exports.ReceiptFoundRewardable]);
/**
 * @returns true if this is a ReceiptFoundRewardable type, false if it's a ReceiptFoundRejected type
 */
function isReceiptRewardable(receipt) {
    return receipt['rejection_reason'] === undefined;
}
exports.EmailParseRequest = zod_1.z.object({
    user: zod_1.z.any(),
    userConnectedEmail: zod_1.z.any(),
    isInitialParse: zod_1.z.any(),
    parseMetrics: zod_1.z.any(),
});
exports.ReceiptItemReward = zod_1.z.object({
    userId: zod_1.z.string(),
    appName: zod_1.z.string(),
    unifiedAppId: zod_1.z.string(),
    emailId: zod_1.z.string(),
    orderDate: zod_1.z.string(),
    orderId: zod_1.z.string(),
    orderItemId: zod_1.z.string(),
    price: zod_1.z.number(),
    currency: zod_1.z.string(),
    isInitialParse: zod_1.z.boolean(),
    isNonRewardable: zod_1.z.boolean(),
    nonRewardReason: zod_1.z.string(),
    platform: zod_1.z.string(),
    hasOtherItems: zod_1.z.boolean(),
    matchType: zod_1.z.string(),
});
exports.ParsedEmailResult = zod_1.z.object({
    createdAt: types_1.FTimestamp,
    updatedAt: types_1.FTimestamp,
    emailId: zod_1.z.string(),
    orderId: zod_1.z.string().nullable(),
    orderItemId: zod_1.z.string().nullable(),
    emailParseRequest: exports.EmailParseRequest.nullable(),
    receiptItemReward: exports.ReceiptItemReward.nullable(),
    appName: zod_1.z.string().nullable(),
    unifiedAppId: zod_1.z.string().nullable(),
    matchType: zod_1.z.string().nullable(),
    failedReason: zod_1.z.string().nullable(),
    failedQueue: zod_1.z.string().nullable(),
    isSuccesfulParse: zod_1.z.boolean(),
    isNonRewardable: zod_1.z.boolean().nullable(),
    nonRewardReason: zod_1.z.string().nullable(),
});
exports.ParsedEmailResultDoc = exports.ParsedEmailResult.merge(types_1.DocId);
var AnalyticVirtualCurrency;
(function (AnalyticVirtualCurrency) {
    AnalyticVirtualCurrency["COINS"] = "coins";
    AnalyticVirtualCurrency["PIGGY_BANKS"] = "piggy_banks";
})(AnalyticVirtualCurrency || (exports.AnalyticVirtualCurrency = AnalyticVirtualCurrency = {}));
exports.AnalyticVirtualCurrencyEnum = zod_1.z.nativeEnum(AnalyticVirtualCurrency);
var VirtualCurrencySpendReason;
(function (VirtualCurrencySpendReason) {
    VirtualCurrencySpendReason["GIFT_CARD"] = "gift_card";
    VirtualCurrencySpendReason["CHEST_PIGGY_BANK"] = "chest_piggy_bank";
    VirtualCurrencySpendReason["STREAK_SAVE"] = "streak_save";
    VirtualCurrencySpendReason["PLAYBACK_ADMIN"] = "playback_admin";
})(VirtualCurrencySpendReason || (exports.VirtualCurrencySpendReason = VirtualCurrencySpendReason = {}));
exports.VirtualCurrencySpendReasonEnum = zod_1.z.nativeEnum(VirtualCurrencySpendReason);
var VirtualCurrencyEarnReason;
(function (VirtualCurrencyEarnReason) {
    VirtualCurrencyEarnReason["ADMIN_REQUEST"] = "postman";
    VirtualCurrencyEarnReason["PLAYBACK_ADMIN"] = "playback_admin";
    VirtualCurrencyEarnReason["RECEIPT_REWARD"] = "receipt_reward";
    VirtualCurrencyEarnReason["CHEST_PIGGY_BANK"] = "chest_piggy_bank";
    // Offer reward reasons
    VirtualCurrencyEarnReason["PLAY_GAME"] = "play_day_x";
    VirtualCurrencyEarnReason["INSTALL_GAME"] = "try_game";
    VirtualCurrencyEarnReason["PLAYTIME"] = "playtime";
    VirtualCurrencyEarnReason["MMP_EVENT"] = "mmp_rewarded_event";
    VirtualCurrencyEarnReason["PURCHASE"] = "purchase_task";
    VirtualCurrencyEarnReason["PURCHASE_AMOUNT"] = "purchase_amount_task";
    // Referral reward reasons
    VirtualCurrencyEarnReason["REFERRED_USER_EARNED_PIGGY"] = "referred_user_earned_piggy_banks";
    VirtualCurrencyEarnReason["REFERRED_USER_REDEEMED_GIFT_CARD"] = "referred_user_redeemed_gift_card";
    // Quest reward reasons
    VirtualCurrencyEarnReason["STARTER"] = "quest_starter";
    VirtualCurrencyEarnReason["FLASH"] = "quest_flash";
    VirtualCurrencyEarnReason["WEEKLY"] = "quest_weekly";
    // Daily Streak reward reasons
    VirtualCurrencyEarnReason["STREAK_SAVE"] = "streak_save";
    VirtualCurrencyEarnReason["STREAK_INCREASE"] = "streak_increase";
})(VirtualCurrencyEarnReason || (exports.VirtualCurrencyEarnReason = VirtualCurrencyEarnReason = {}));
exports.VirtualCurrencyEarnReasonEnum = zod_1.z.nativeEnum(VirtualCurrencyEarnReason);
const CurrencyEventData = zod_1.z.object({
    event_id: zod_1.z.string(),
    time: zod_1.z.number(),
    user_id: zod_1.z.string(),
    value: zod_1.z.number(),
    virtual_currency_name: exports.AnalyticVirtualCurrencyEnum,
    on_hand_remaining: zod_1.z.number(),
});
exports.CurrencySpendEventData = CurrencyEventData.extend({
    item_name: exports.VirtualCurrencySpendReasonEnum,
});
exports.CurrencyEarnEventData = CurrencyEventData.extend({
    reason: exports.VirtualCurrencyEarnReasonEnum,
    referral_code: zod_1.z.string().optional(),
    referred_user_id: zod_1.z.string().optional(),
    task_event: zod_1.z.string().optional(),
});
exports.GiftCardPurchaseEventData = zod_1.z.object({
    event_id: zod_1.z.string(),
    gift_card_type: zod_1.z.string(),
    session_id: zod_1.z.string(),
    time: zod_1.z.number(),
    user_id: zod_1.z.string(),
    usd_value: zod_1.z.number(),
});
exports.UserSignUpEventData = zod_1.z.object({
    method: zod_1.z.string(),
    country: zod_1.z.string().nullable(),
    email: zod_1.z.string(),
    preferred_storefront: zod_1.z.string(),
    sign_up_platform: zod_1.z.string(),
    event_id: zod_1.z.string().optional(),
});
